// extracted by css-extract-rspack-plugin
export default {"Box":"OverviewHeader-module__Box__cC1RH","PublishBanners":"OverviewHeader-module__PublishBanners__iqAgf"};